import { useState, useEffect, useCallback, useContext } from 'react';
import { getOrganizations } from '../../services/Universities/universitiesService';
import SmashLoader from '../../components/Loader/SmashLoader';
import { useNavigate, useParams } from 'react-router-dom';
import UniversityProfileWidget from './UniversityProfileWidget';
import NotFound from '../NotFound/NotFound';
import { UserContext } from '../../utils/contexts/UserContext';

export default function University() {
  const navigate = useNavigate();
  const { uuid } = useParams();
  const { isStudent } = useContext(UserContext);
  const [university, setUniversity] = useState(null);
  const [loading, setLoading] = useState(true);

  const getData = useCallback(
    (signal) => {
      setLoading(true);
      getOrganizations({ uuid, signal })
        .then((res) => {
          setUniversity(res);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          if (!signal.aborted) {
            setLoading(false);
          }
        });
    },
    [uuid],
  );

  useEffect(() => {
    const controller = new AbortController();
    getData(controller.signal);
    return () => controller.abort();
  }, [getData]);

  if (loading)
    return (
      <div>
        <SmashLoader />
      </div>
    );

  if (!university) {
    return <NotFound />;
  }

  return (
    <div className="min-h-screen font-inter transition-colors duration-300">
      <main className="max-w-7xl mx-auto py-8 px-4 md:px-8">
        <UniversityProfileWidget university={university} />
      </main>
      {isStudent && (
        <div className="flex justify-end pr-8 gap-4">
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-md"
            onClick={() => navigate('/organizations')}
          >
            Back
          </button>
          <button
            className="bg-blue-500 text-white px-4 py-2 rounded-md"
            onClick={() => navigate('interviews')}
          >
            View interviews
          </button>
        </div>
      )}
    </div>
  );
}
